module.exports = __webpack_public_path__ + "static/testi-1-2-fd820235bfd54eefc6964309d4140b2d.jpg";